import { formatWithThousandSeparators } from '@shared-core/utils/balances/balances'
import { Big } from '@shared-core/utils/balances/big'
import { useState } from 'react'

export type InputCurrency = 'usd' | 'rub'

// Сохраняем введённую дробную часть, включая незавершённую запятую.
export function formatInputAmount(raw: string): string {
  return formatWithThousandSeparators(raw.replace(',', '.')).replace('.', ',')
}

export function toInputAmount(value: Big, isRoundDown = false): string {
  return value
    .toFixed(2, isRoundDown ? Big.roundDown : Big.roundHalfUp)
    .replace(/\.00$/, '')
    .replace(/(\.\d)0$/, '$1')
    .replace('.', ',')
}

export function useCurrencyAmount(rate?: string, isRoundDown = false) {
  const [raw, setRaw] = useState('')
  const [inputCurrency, setInputCurrency] = useState<InputCurrency>('usd')
  const amount = raw.replace(',', '.') || '0'
  const convertedUsd = rate ? Big(amount).div(rate) : Big('0')
  const amountUsd = inputCurrency === 'usd' ? Big(amount) : convertedUsd
  const convertedRub = rate ? Big(amount).times(rate) : Big('0')
  const amountRub = inputCurrency === 'rub' ? Big(amount) : convertedRub
  // Ограничения ввода: одна запятая, максимум 2 знака после неё и 8 цифр всего.
  // Проверки идут внутри сеттера, чтобы опираться на актуальное значение.
  const handleKey = (key: string) =>
    setRaw((value) => {
      if (key === 'backspace') return value.slice(0, -1)

      if (key === ',') {
        if (value.includes(',')) return value
        return value ? `${value},` : '0,'
      }

      if (!/^\d$/.test(key)) return value

      if (key === '0' && value === '') return '0,'

      if (value === '0') return `0,${key}`

      if (value.includes(',') && (value.split(',')[1]?.length ?? 0) >= 2) return value

      if (value.replace(',', '').length >= 8) return value
      return `${value}${key}`
    })
  const convert = () => {
    if (!rate) return
    setRaw(toInputAmount(inputCurrency === 'usd' ? amountRub : amountUsd, isRoundDown))
    setInputCurrency((currency) => (currency === 'usd' ? 'rub' : 'usd'))
  }
  return { raw, inputCurrency, amount, amountUsd, amountRub, events: { setRaw, setInputCurrency, handleKey, convert } }
}
